export const PlusIcon = ({color = "white", size = 30}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"  fill={color}>
        <path fill="#ffffff"
              d="M7 12h4V8h1v4h4v1h-4v4h-1v-4H7v-1M6 4h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3m0 1a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6Z"/>
    </svg>
);
